
export function sorting(arr, key) {
    let result = Array.isArray(arr) && arr.sort((a, b) => {
        return a[key].trim().toLowerCase().localeCompare(b[key].trim().toLowerCase());
    });
    return result;
}